import React, { useEffect, useState } from 'react';
import { CreditCard, FileCheck2, Maximize2 } from 'lucide-react';

const datum = (d) => (d ? d.split('-').reverse().join('.') : '');

export const RechnungPdfVorschau = ({ datei, info }) => {
  const [url, setUrl] = useState('');
  useEffect(() => {
    if (!datei) { setUrl(''); return undefined; }
    const u = URL.createObjectURL(datei);
    setUrl(u);
    return () => URL.revokeObjectURL(u);
  }, [datei]);
  if (!url) return null;
  return (
    <div className="space-y-2" data-testid="rechnung-vorschau">
      <div className="flex flex-wrap items-center gap-2 text-[11px]">
        {info?.quelle && <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-emerald-50 text-emerald-800 border border-emerald-200" data-testid="rechnung-quelle"><FileCheck2 className="w-3 h-3" />{info.quelle} – Werte direkt aus der E-Rechnung</span>}
        {info?.rechnungsdatum && <span className="px-2 py-0.5 rounded-full bg-[#f5f8fa] border border-gray-200 text-[#34536b]">Rechnungsdatum {datum(info.rechnungsdatum)}</span>}
        {info?.aktenzeichen && <span className="px-2 py-0.5 rounded-full bg-[#f5f8fa] border border-gray-200 text-[#34536b]" data-testid="rechnung-az-erkannt">Az. {info.aktenzeichen}{info.case_id ? ' · Akte gefunden' : ' · keine Akte im Portal'}</span>}
        {info?.lastschrift && <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-sky-50 text-sky-800 border border-sky-200" data-testid="rechnung-lastschrift"><CreditCard className="w-3 h-3" />wird per SEPA-Lastschrift eingezogen</span>}
        <a href={url} target="_blank" rel="noreferrer" className="ml-auto inline-flex items-center gap-1 text-[#b8893d] hover:underline" data-testid="rechnung-vorschau-gross"><Maximize2 className="w-3 h-3" />Groß öffnen</a>
      </div>
      <iframe title="Rechnungsvorschau" src={`${url}#toolbar=0&navpanes=0&view=FitH`} className="w-full h-[62vh] min-h-[420px] rounded-xl border border-gray-200 bg-[#f8fafc]" data-testid="rechnung-vorschau-frame" />
    </div>
  );
};
